module.exports = __webpack_public_path__ + "img/illustration.f274e863.png";